/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, price: NonNullable<unknown> }} Sub_Addons_Storage_CurrentInputs */



/**
* | output |
* | --- |
* | "Current: {label}, €{price}/mo" |
*
* @param {Sub_Addons_Storage_CurrentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_storage_current = /** @type {((inputs: Sub_Addons_Storage_CurrentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Storage_CurrentInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Aktuell: ${i?.label}, €${i?.price}/Mo.`)
	return /** @type {LocalizedString} */ (`Current: ${i?.label}, €${i?.price}/mo`)
});